@if (shipmentInformation$ | async) {
  <div id="shipmentInformation" [formGroup]="shipmentInformationForm">
    @for (objs of shipmentInformationForm.get('packages')['controls']; track objs; let i = $index) {
      <div formArrayName="packages">
        <ng-container [formGroupName]="i">
          @if (this.shipmentInformationForm.get('packages')['controls'][i]['controls'].shipmentType.value !== '') {
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <legend class="usa-legend usa-legend--medium">
                {{this.shipmentInformationForm.get('packages')['controls'][i]['controls'].shipmentType.value}}</legend>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="totalPieces" class="usa-label">Package Total Pieces</label>
                <input type="text" class="usa-input maxw-full" id="totalPieces" formControlName="totalPieces" readonly="true" />
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="packageType" class="usa-label">
                  Package Type
                </label>
                <input type="text" class="usa-input maxw-full" id="packageType" formControlName="packageType" readonly="true" />
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="shipmentDescription" class="usa-label">
                  Description Of Shipment<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                </label>
                <input type="text" id="shipmentDescription" class="usa-input maxw-full" formControlName="packageDescription" />
                @if ((this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value).invalid && (this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value.touched || this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value.dirty)) {
                  <div class="define-text-secondary">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg>Package Description is required
                  </div>
                }
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
                <label for="additionalInformation" class="usa-label maxw-full">
                  Additional Information
                </label>
                <textarea type="text" id="additionalInformation" rows="2" class="usa-textarea maxw-full" formControlName="additionalInfo">
                </textarea>
              </div>
            </div>
          }
        </ng-container>
      </div>
    }
  </div>
}
<!--

<div id="shipmentInformation" [formGroup]="shipmentInformationForm" *ngIf="shipmentInformation$ | async">
  <div formArrayName="packages" *ngFor="let objs of shipmentInformationForm.get('packages')['controls']; let i = index">
    <ng-container [formGroupName]="i">
      <div *ngIf="this.shipmentInformationForm.get('packages')['controls'][i]['controls'].shipmentType.value !== ''">
        <div class="py-3">
          <h5 class="p-3 mb-2 bol-info-headingBackground text-dark">
            {{this.shipmentInformationForm.get('packages')['controls'][i]['controls'].shipmentType.value}}
          </h5>
        </div>
        <div class="form-row">
          <div class="col-md-3">
            <label for="totalPieces" class="noMarginLeft">
              Package Total Pieces
            </label>
            <input type="text" class="form-control-plaintext" id="totalPieces" formControlName="totalPieces" readonly="true" />
          </div>
          <div class="col-md-3">
            <label for="packageType" class="noMarginLeft">
              Package Type
            </label>
            <input type="text" class="form-control-plaintext" id="packageType" formControlName="packageType" readonly="true" />
          </div>
          <div class="col-md-3">
            <label for="shipmentDescription" class="noMarginLeft">
              Description Of Shipment
            </label>
            <small class="bol-info-required">*</small>
            <input type="text" id="shipmentDescription" class="w-100" formControlName="packageDescription" />
          </div>

          <div class="text-danger" *ngIf="(this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value).invalid && (this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value.touched || this.shipmentInformationForm.get('packages')['controls'][i]['controls'].packageDescription.value.dirty)">
            <span class="fa fa-warning"></span>Package Description is required
          </div>

          <div class="col-md-3">
            <label for="additionalInformation" class="noMarginLeft">
              Additional Information
            </label>
            <textarea type="text" id="additionalInformation" rows="2" class="w-100" formControlName="additionalInfo">
            </textarea>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div> -->